
import React from 'react';
import { Briefcase, MessageCircle, Phone, Mail, Instagram, Facebook, MapPin, Users } from 'lucide-react';
import QRCodeGenerator from '../common/QRCodeGenerator';
import MapComponent from '../common/MapComponent';

const ConsultingLinktree = () => {
  const socialLinks = [
    { icon: Instagram, url: "https://www.instagram.com/decidedigitaloficial" },
    { icon: Facebook, url: "https://www.facebook.com/decidedigitaloficial" },
  ];

  const mainLinks = [
    {
      icon: Briefcase,
      title: "Nossos Serviços",
      subtitle: "Consultoria especializada",
      url: "https://decidedigital.com.br/"
    },
    {
      icon: MessageCircle,
      title: "Consulta via WhatsApp",
      subtitle: "Agende uma conversa",
      url: "https://wa.me/5569992083972?text=Ol%C3%A1%20eu%20gostaria%20de%20informa%C3%A7%C3%B5es%20sobre%20as%20solu%C3%A7%C3%B5es%20da%20Decide%20Digital!"
    },
    {
      icon: Phone,
      title: "Contato Direto",
      subtitle: "(69) 99208-3972",
      url: "tel:+5569992083972"
    },
    {
      icon: Mail,
      title: "E-mail Profissional",
      subtitle: "contato@decidedigital.com.br",
      url: "mailto:contato@decidedigital.com.br"
    },
    {
      icon: MapPin,
      title: "Nosso Escritório",
      subtitle: "Visite-nos pessoalmente",
      url: "https://maps.app.goo.gl/67vmppvo3ERddDZQ9"
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4">
      <div className="max-w-md mx-auto">
        <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 mb-8 animate-fade-in">
          <div className="text-center">
            <div className="w-24 h-24 mx-auto mb-6 bg-slate-900 rounded-2xl flex items-center justify-center">
              <Users className="w-10 h-10 text-white" />
            </div>
            <h1 className="text-2xl font-bold text-gray-900 mb-3">Decide Digital</h1>
            <h2 className="text-lg font-medium text-gray-700 mb-4">Consultoria Digital</h2>
            <p className="text-gray-600 leading-relaxed text-sm">
              Consultoria especializada em transformação digital. Ajudamos empresas a 
              crescer e se destacar no ambiente digital com estratégias personalizadas 
              e soluções eficazes.
            </p>
          </div>
        </div>

        <div className="bg-white rounded-2xl p-4 shadow-sm border border-gray-100 mb-6 text-center animate-scale-in">
          <p className="text-gray-700 text-sm mb-3">Acesse nossos serviços:</p>
          <div className="flex justify-center">
            <QRCodeGenerator url="https://decidedigital.com.br/" size={100} />
          </div>
        </div>

        <div className="flex justify-center space-x-4 mb-8">
          {socialLinks.map((social, index) => (
            <a
              key={index}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`w-12 h-12 bg-slate-900 rounded-xl flex items-center justify-center hover:bg-slate-800 link-button animate-scale-in animate-delay-${index * 100}`}
            >
              <social.icon className="w-5 h-5 text-white" />
            </a>
          ))}
        </div>

        <div className="space-y-4">
          {mainLinks.map((link, index) => (
            <a
              key={index}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`block w-full p-5 bg-white border border-gray-200 rounded-2xl hover:border-gray-300 hover:shadow-md link-button animate-fade-in animate-delay-${index * 100}`}
            >
              <div className="flex items-center">
                <div className="w-12 h-12 bg-gray-100 rounded-xl flex items-center justify-center mr-4">
                  <link.icon className="w-6 h-6 text-gray-700" />
                </div>
                <div className="flex-1">
                  <div className="font-semibold text-gray-900">{link.title}</div>
                  <div className="text-sm text-gray-600">{link.subtitle}</div>
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className="bg-white rounded-2xl p-4 shadow-sm border border-gray-100 mt-6 animate-fade-in">
          <p className="text-gray-700 text-sm mb-3 font-medium text-center">Localização do escritório:</p>
          <MapComponent 
            latitude={-8.7619} 
            longitude={-63.9019} 
            zoom={17}
            category="consulting"
            popupText="Decide Digital - Escritório de Consultoria"
          />
        </div>

        <div className="bg-slate-900 rounded-2xl p-6 mt-8 text-center text-white animate-fade-in">
          <h3 className="font-semibold mb-2">Pronto para transformar seu negócio?</h3>
          <p className="text-sm text-gray-300">
            Entre em contato conosco e descubra como podemos ajudar
          </p>
        </div>
      </div>
    </div>
  );
};

export default ConsultingLinktree;
